var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6bdcd0de7bbbc4ac36cbb003f072922af2385b89"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cube-front@rac"]={id:"6bdcd0de7bbbc4ac36cbb003f072922af2385b89"};
      